<template>
	<div>
		<shutter-panel ref="shutterPanel" />
	</div>
</template>


<script type="text/javascript">
	import Shutter from "@/mixins/Shutter.js"
	import ShutterInvoice from "@/mixins/shutters-manager/Invoice.js"

	export default {
		name: "InvoiceSupplierFicheVentilation",
		mixins: [Shutter, ShutterInvoice],
		props: {
			invoice: { type: Object, default: () => ({}) },
			invoicesupplier_id: { type: [String, Number], default: null }
		},

		watch: {
			// La fiche recharge la facture après chaque enregistrement : le formulaire se refait alors
			// sur les données à jour, sans quoi il continuerait d'afficher celles de son ouverture.
			invoice: 'openForm'
		},

		methods: {
			/**
			 * Ouvre le formulaire de ventilation de l'application plutôt que d'en écrire un second : la
			 * reprise des lignes de TVA reconnues, les comptes les plus utilisés pour ce fournisseur et
			 * le contrôle des sommes y sont déjà traités. L'onglet n'en est que le point d'entrée.
			 */
			openForm() {
				const shutters = this.getInvoicesShutter({
					invoice_supplier: this.invoice
				})

				this.shutterPanel().open(shutters['invoice-supplier-charge-account'])
			},

			/**
			 * Rappelée par le formulaire après enregistrement — le nom est celui qu'attend sa
			 * définition. Le statut d'export de la facture change avec sa ventilation : le bandeau et
			 * le formulaire lui-même en dépendent.
			 */
			loadInvoicesSupplier() {
				this.$emit('invoice-updated')
			}
		},

		mounted() {
			// Tant que la facture n'est entrée dans aucun circuit — ni contrôlée chez nous, ni prise en
			// charge auprès du fournisseur — ses montants ne sont pas arrêtés : les ventiler reviendrait
			// à imputer des sommes qui bougeront encore. L'onglet est grisé, son adresse reste
			// atteignable.
			const is_checked = this.invoice.suppliersocr_ocr_status === 'checked' || this.invoice.suppliersocr_acknowledged

			if(!is_checked) {
				this.$router.replace({ name: 'invoiceSupplierFicheOverview', params: { invoicesupplier_id: this.invoice.suppliersocr_id } })
				return
			}

			this.openForm()
		}
	}
</script>
